export const mapData = ({
  location = {},
  stakeholders = [],
  groups = [],
}) => {
  if (Object.keys(location).length) {
    const all = { location: { ...location, type: 'STAKEHOLDER' } };
    const children = [];

    groups.forEach((group, i) => {
      const stakeholdersHere = stakeholders
        .filter((s) => s.group === group)
        .map((s) => ({
          ...s,
          type: 'STAKEHOLDER',
          parentId: `SEC-${i + 1}`,
        }));

      if (stakeholdersHere.length === 0) {
        stakeholdersHere.push({
          type: 'BLANK',
          parentId: `SEC-${i + 1}`,
          id: `BLANK-${i + 1}`,
        });
      }

      const item = {
        type: 'SECTION',
        name: group,
        id: `SEC-${i + 1}`,
        childrens: stakeholdersHere,
      };

      children.push(item);
    });

    all.location.childrens = children;
    return all;
  } else {
    return { location: {}, stakeholders: [] };
  }
};
